<app-views-list class="bg-primaryBackground pb-2"></app-views-list>
<ng-container *ngIf="selectedView$ | async as view">
    <ng-container [ngSwitch]="view.type_code.value">
        <app-table-container *ngSwitchCase="ViewTypeCodes.TABLE"></app-table-container>
        <app-board *ngSwitchCase="ViewTypeCodes.BOARD"></app-board>
        <app-list *ngSwitchCase="ViewTypeCodes.LIST"></app-list>
    </ng-container>
</ng-container>
